import store from '@/store';

export default class BroadcastWhatsAppListQueuedEvent {
  constructor(body) {
    const agentId = store.state.attendance.Attendance.agentId;
    const broadcastWhatsAppId = body.id;
    if (
      body.event == 'BroadcastWhatsAppListQueuedEvent' &&
      agentId == body.agentId
    ) {
      const broadcastInformation = {
        broadcastWhatsAppId,
        status: 'QUEUED',
        type: 'default',
      };
      store.dispatch(
        'broadcast/updateBroadcastWhatsAppStatus',
        broadcastInformation,
      );
      console.log(
        '[AGENT/BROADCAST] - Broadcast ' +
          broadcastWhatsAppId +
          ' agendado pelo sistema.',
      );
    }
  }
}
